import { Divider } from "@msuite/ui/divider";
import { useTranslation } from "@msuite/ui/localization";
import { moment } from "@msuite/utils/date";
import React from "react";

/** Props Interface */
interface PorjectTimelineItemMetaProps {
	timestamp: string;
}

export function PorjectTimelineItemMeta({ timestamp }: PorjectTimelineItemMetaProps) {
	/** Hooks */
	const { language } = useTranslation();

	/** Render */
	return (
		<React.Fragment>
			<p className="label">{moment(timestamp).locale(language).longFormat()}</p>
			<Divider variant="card" />
		</React.Fragment>
	);
}
